<template>
  <div v-if="position === 'fixed'" class="loading-fixed" v-bind="$attrs">
    <div class="loading-spinner">
      <div class="spinner"></div>
      <p v-if="message">{{ message }}</p>
    </div>
  </div>
  <!-- `position` est plus spécifique que `overlay` (qui vaut `true` par défaut) :
       il est donc testé AVANT. Sans cet ordre, `position="inline"` rendait quand
       même `.loading-overlay` — un absolu `inset: 0` qui, faute d'ancêtre
       positionné, s'étalait sur toute la page et passait sous les `thead`
       collants des tableaux (z-index 1020). -->
  <div v-else-if="position !== 'inline' && overlay" class="loading-overlay" v-bind="$attrs">
    <div class="loading-spinner">
      <div class="spinner"></div>
      <p v-if="message">{{ message }}</p>
    </div>
  </div>
  <div v-else class="loading-inline" v-bind="$attrs">
    <div class="spinner"></div>
    <p v-if="message">{{ message }}</p>
  </div>
</template>

<script setup>
defineProps({
  overlay: {
    type: Boolean,
    default: true
  },
  position: {
    type: String,
    default: null,
    validator: (value) => !value || ['fixed', 'overlay', 'inline'].includes(value)
  },
  message: {
    type: String,
    default: 'Chargement...'
  }
})
</script>

<style scoped>
.loading-fixed {
  position: fixed;
  bottom: var(--spacing-lg);
  right: var(--spacing-lg);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: var(--radius-md);
}

.loading-inline {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-xl);
  gap: var(--spacing-md);
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-md) var(--spacing-xl);
  background: var(--color-bg-primary);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--color-border);
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--color-border-light);
  border-top-color: var(--color-primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-spinner p,
.loading-inline p {
  color: var(--color-text-secondary);
  font-size: 0.9rem;
  margin: 0;
}
</style>

